import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
const LAZY_LIMIT = 100;
/**
 * Should be in a global place
 * @link https://stackoverflow.com/questions/847185/convert-a-unix-timestamp-to-time-in-javascript
 */
export const unixToDate = (unix) => {
    const dateObject = new Date(unix);
    const year = dateObject.getFullYear() % 100;
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const day = String(dateObject.getDate()).padStart(2, '0');
    const hours = String(dateObject.getHours()).padStart(2, '0');
    const minutes = String(dateObject.getMinutes()).padStart(2, '0');
    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes}`;
    return formattedDate;
};
const orderData = (data) => {
    data.sort(function (a, b) {
        return (b._Time ?? 0) - (a._Time ?? 0);
    });
    return data;
};
const headerOrder = (all, provided) => {
    const timeIndex = all.findIndex((one) => one === '_Time');
    // ensure data correctness
    if (all.length === 0 || timeIndex === undefined) {
        // DEBUG && console.log('Something has gone wrong', all);
        return [];
    }
    const timelessCopy = [...all];
    timelessCopy.splice(timeIndex, 1);
    if (!provided) {
        timelessCopy.push('_Time');
        return timelessCopy;
    }
    // get all valid provided strings
    const valid = provided.filter((header) => timelessCopy.includes(header));
    // find headers not specified
    const notIn = timelessCopy.filter((header) => !valid.includes(header));
    const combined = provided.concat(notIn);
    combined.push('_Time');
    return combined;
};
const getHeader = (data) => {
    if (data.length === 0) {
        return [];
    }
    // lazy, but should be correct
    // use when the data is large
    const base = Object.keys(data[0]);
    if (data.length * base.length > LAZY_LIMIT) {
        return base;
    }
    const header = data.reduce((combinedSet, row) => {
        Object.keys(row).forEach((key) => {
            combinedSet.add(key);
        });
        return combinedSet;
    }, new Set());
    return Array.from(header.values());
};
const formatHeader = (header) => {
    if (header.indexOf('_') === 0) {
        return _jsx(TableCell, { align: "right", children: header.substring(1) });
    }
    return _jsx(TableCell, { align: "left", children: header });
};
const formatRow = (row, order) => {
    return (_jsx(TableRow, { children: order.map((key) => {
            let formatted = row[key];
            if (key === '_Time' && typeof formatted === 'number') {
                formatted = unixToDate(formatted);
                return (_jsx(TableCell, { align: "right", children: formatted }, key));
            }
            return _jsx(TableCell, { children: formatted }, key);
        }) }, row._Time));
};
const CommonTableGraph = ({ data, order }) => {
    const constructedOrder = headerOrder(getHeader(data), order);
    return (_jsx("div", { children: _jsx(TableContainer, { component: Paper, children: _jsxs(Table, { sx: { minWidth: 650 }, "aria-label": "simple table", children: [_jsx(TableHead, { children: _jsx(TableRow, { style: { backgroundColor: 'lightgray' }, children: constructedOrder.map((header) => {
                                return formatHeader(header);
                            }) }) }), _jsx(TableBody, { children: orderData(data).map((row) => {
                            return formatRow(row, constructedOrder);
                        }) })] }) }) }));
};
export default CommonTableGraph;
